import * as React from 'react';

import '@app/scss/pages/home.scss';
import '@app/scss/components/banner.scss';
import RequestDemoLinkBlock from '@app/components/UI/components/RequestDemoLinkBlock';

const floridaDMVSolutions = [
	'New Vehicle Registrations',
	'Temporary Tags & Permits',
	'Mechanic Liens',
	'Vehicle Title Transfers',
	'VIN Verifications',
	'Registration Renewals',
	'Personalized & Specialty License Plates',
	'Mobile Home & Commercial Fleet Registrations',
	'Boat Registrations',
	'Duplicate Title Services',
];

const nationwideDealerSolutions = [
	'Accurate Fee Quotes',
	'Fast-Track Expert Processing',
	<>Title Corrections & Duplicate Tiles</>,
	'24/7 Customer Support',
	'Real-Time Transaction Tracking',
	'Comprehensive Dealer Training',
	<>Pre-Filled Forms <br className="show-mobile"/> & Documentation Guides</>,
	'Continuous Compliance Management',
	<>Integration with Leading <br className="show-mobile"/> DMS Platforms</>,
	'Instant NMVTIS Compliance Checks',
];

const Home: React.FC = () => {
	return (
		<div className="home-page home">
			<div className="top-banner" id="home">
				<div className="image-block">
					<picture>
						<source media="(max-width: 600px)" srcSet="/images/home-image-1.png" />
						<source media="(max-width: 768px)" srcSet="/images/home-image-1.png" />
						<source media="(min-width: 769px)" srcSet="/images/home-image-1.png" />
						<img className="top-banner__image" alt="banner" srcSet="/images/home-image-1.png" />
					</picture>
					<div className="banner-text">
						<h1>Executive Tags</h1>
						<h2>
							Your Premier DMV Partner
						</h2>
						<h4>
							Simplifying DMV Solutions Nationwide
						</h4>
					</div>
				</div>
			</div>
			<div className="second-block">
				<div className="blue-block">
					<div className="content-block padding-m">
						<div className="row">
							<div className="col-sm-6 text-end">
								Established in 2006 and based in West Palm Beach, Florida, Executive Tags is your trusted expert in efficient,
								hassle-free vehicle titling, registration and compliance solutions. We streamline DMV processes for automotive
								dealerships and individuals, providing clarity, efficiency, and peace of mind.
							</div>
						</div>
					</div>
				</div>
				<div className="is-relative" style={{marginTop: 105}}>
					<div className="skew-block-right">
						<div className="skew-block blue-dark-border skew-padding-s" style={{ paddingLeft: 0, paddingRight: 0 }}>
							<h3
								className="text-primary text-italic content-block"
								style={{
									fontWeight: 600,
									marginBottom: 0,
									maxWidth: 1700,
									paddingLeft: 73,
									paddingRight: 73,
								}}
							>
								Yadira Amuial—Founder
							</h3>
						</div>
					</div>
					<div className="content-block is-relative">
						<img
							className="home-image-2"
							src="/images/home-image-2.png"
						/>
					</div>
				</div>
			</div>
			<div style={{marginBottom: 30}}>
				<div className="skew-block-left">
					<div className="blue-dark-block skew-block skew-padding-s">
						<h2 className="margin-0">
							Why Choose Executive Tags?
						</h2>
					</div>
				</div>
				<div className="content-block">
					<div className="col-3-block">
						<div>
							<p>
								<b className="text-primary">
									Reduce DMV Headaches
								</b>
								<br />
								<span className="grey-color">
									Minimize confusion, paperwork, and phone calls with our user-friendly digital platform.
								</span>
							</p>
						</div>
						<div>
							<p>
								<b className="text-primary">
									Expert Processing Center
								</b>
								<br />
								<span className="grey-color">
									Let our skilled DMV specialists handle the paperwork, allowing your team to focus on core business tasks.
								</span>
							</p>
						</div>
						<div>
							<p>
								<b className="text-primary">
									Proactive Communication
								</b>
								<br />
								<span className="grey-color">
									Stay informed every step of the way with real-time tracking and responsive client updates.
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="blue-block padding-m">
				<h3 className="text-center text-left-m white-text weight-normal text-italic content-block" style={{ margin: 0}}>
					Comprehensive &nbsp;<br className="show-mobile" /><b>DMV Services</b>&nbsp; Tailored for You
				</h3>
			</div>
			<div className="home-custom-block-1">
				<div className="skew-padding-text">
					<div className="skew-block-left">
						<div className="skew-block blue-border skew-padding-s">
							<h3 className="margin-0">
								<b>Florida DMV Solutions</b>
							</h3>
						</div>
					</div>
				</div>
				<div className="skew-block blue-dark-border transform-top">
					<div className="content-block transform-top">
						<div className="col-3-block">
							{floridaDMVSolutions.map(text => <p key={text}>
								<span style={{fontWeight: 600}}>{text}</span>
							</p>)}
						</div>
					</div>
				</div>
			</div>
			<div className="home-custom-block-2">
				<div className="skew-padding-text">
					<div className="skew-block-right skew-block-right_home">
						<div className="skew-block blue-border skew-padding-s">
							<div className="content-block">
								<h3 className="margin-0">
									<b>
										Nationwide
										<br className="show-mobile" />
										Dealer Solutions
									</b>
								</h3>
							</div>
						</div>
					</div>
				</div>
				<div className="skew-block blue-dark-border">
				<div className="content-block text-end">
						<div className="col-2-block">
							{nationwideDealerSolutions.map((text, i) => <p key={i}>
								<span style={{fontWeight: 600}}>{text}</span>
							</p>)}
						</div>
					</div>
				</div>
			</div>
			<RequestDemoLinkBlock
				content={<>
					<h4 className="white-text">
						Partner with Confidence
					</h4>
					<p style={{ fontWeight: 400 }}>
						Let Executive Tags simplify your DMV tasks, empowering your dealership to deliver outstanding service and efficiency.
						You focus on your customers—we'll handle the rest.
					</p>
					<p>
						<b>
							Ready to Streamline Your DMV Process?
						</b>
					</p>
				</>}
			/>
		</div>);
};

export default Home;
